import axios from 'axios'
import { auth } from '@open-platform/firebase-client'

axios.defaults.baseURL = process.env.REACT_APP_API_URL
//axios.defaults.baseURL = "http://10.0.2.2:3001"
axios.interceptors.request.use(
  async requestConfig => {
//console.log("-------URL")
//console.log(axios.defaults.baseURL)
    if (auth.currentUser) {
//console.log("-------auth")
//console.log(auth.currentUser.getIdToken())
      const token = await auth.currentUser.getIdToken()
      requestConfig.headers['Authorization'] = `Bearer ${token}`
    }
    return requestConfig
  },
  error => {
//console.log("-------error")
//console.log(error)
    return Promise.reject(error)
  }
)

export { axios }
